import { colors } from 'Theme';

export default {
  signatureBox: {
    backgroundColor: '#282626',
    border: '1px solid #7a7a7a',
    borderRadius: '6px',
    overflow: 'hidden',
    position: 'relative'
  },

  signatureImg: {
    display: 'block',
    width: '100%',
    filter: 'invert(1)'
  },

  centerImage: {
    display: 'flex',
    margin: '6px auto'
  },

  signaturePlaceholder: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#7a7a7a',
    fontSize: '14px',
    pointerEvents: 'none'
  },

  redBorder: {
    borderColor: colors.error
  },

  signatureSheetStyle: {
    height: 'auto',
    '--f7-sheet-bg-color': '#282626'
  }
};
